// See details in https://firstdatateam.atlassian.net/browse/CLDI-1594
export const invalidFdmpEmailDomains = new Set([
  'noermail.com',
  'awbank.net',
  'associatedbank.com',
  'bankmutal.com',
  'bankmutaaaaaaaal.com',
  'bankofamerica.com',
  'bankofamericamerchantservices.com',
  'bankofamerica.comcom',
  'bankofamreicamerchant.com',
  'boa.com',
  'bams.com',
  'bankozarks.com',
  'bbva.com',
  'cathaybank.com',
  'chemicalbankmi.com',
  'citi.com',
  'wellsfargo.com',
  'rabobank.com',
  'totalbank.com',
  'fairwinds.com',
  'firstambank.com',
  'fbol.com',
  'myfcbtexas.com',
  'firstdata.com',
  'fnbalaska.com',
  'forchtbank.com',
  'frostbank.com',
  'dontask.com',
  'hancockbank.com',
  'whitneybank.com',
  'huntington.com',
  'mechanicsbank.com',
  'nwbcorp.com',
  'pnc.com',
  'santander.com',
  'sovereignbank.com',
  'sovereingbank.com',
  'suntrust.com',
  'tcfbank.com',
  'websterbank.com',
  'bankmutual.com',
  'bankmutuaaaaaaaal.com',
  'bankofamerica.com.com',
  'bankofamericamerchant.com',
  'santander.us',
  'standardbanks.com',
  'none.com',
  'na.com',
  'fawbank.net',
  'bofa.com',
  'baml.com',
  'ggmail.com',
  'gmial.com',
  'yaho.com',
  'noemail.com',
  'nowhere.com',
  'citi.com',
  'standardbank.com',
]);
